/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useEffect, useState } from 'react';
import { ScrollView, Text, View } from 'react-native';

import { AuthDepartmentStore } from '../../stores/department/auth-department-store';
import { BfAppContext } from '@tw/tw-runtime';
import { BfPageStoreProvider } from '@tw/tw-runtime-react';
import { DepartmentSelect2 } from '@/gift/pages/department/viewparts/department-select/DepartmentSelect2';
import { TwButton } from '@/app/components/tw-button/TwButton';
import { TwPage } from '@tw/tw-components-rn';
import { styles } from './styles';
import { usePageStoreLifecycle } from '@tw/tw-runtime-react';

export const AuthDepartmentEdit = () => {
  const [store] = useState(() => new AuthDepartmentStore());
  usePageStoreLifecycle(store, undefined);
  const [department, setDepartment] = useState(
    BfAppContext.getInstance().getUserStore().getState().userInfo.employee?.departmentId
  );
  const [inputValue, setInputValue] = useState(
    BfAppContext.getInstance().getUserStore().getState().userInfo.employee?.departmentId?.name
  );

  const onInputValueChange = (text: string) => {
    setInputValue(text);
    setDepartment(null);
  };

  const onDepartmentSelect = (department) => {
    setDepartment(department);
    setInputValue(department.name);
  };

  console.log('AuthDepartmentEdit', department);

  return (
    <BfPageStoreProvider store={store}>
      <TwPage
        translucentStatusBar={true}
        footer={
          <View style={styles.footer}>
            <TwButton
              variant={'solid'}
              onPress={async () => {
                await store.update(department);
                BfAppContext.getInstance().getRouteService().back();
              }}
              isDisabled={
                !department ||
                !department.id ||
                department.id ===
                  BfAppContext.getInstance().getUserStore().getState().userInfo.employee?.departmentId.id
              }
            >
              确认
            </TwButton>
          </View>
        }
      >
        <TwPage.Header title={'修改部门'}></TwPage.Header>

        <ScrollView style={styles.container}>
          <DepartmentSelect2
            enableSearch={true}
            inputValue={inputValue}
            department={department}
            onChange={onInputValueChange}
            onSelect={onDepartmentSelect}
          />
        </ScrollView>
      </TwPage>
    </BfPageStoreProvider>
  );
};
